
<app-title-section></app-title-section>

<div class="card p-1"  style="margin-left: 15px; margin-right: 15px; min-height:100vh;">

    <ul class="nav nav-tabs m-0 " style=" border-bottom: 1px solid #eee;" *ngIf="statusCounts$ | async as counts">
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/tous']" [class.active]="currentStatus === 'tous'" (click)="filterByStatus('tous')">
                    Tous <app-tab-count [count]="counts['Tous'] ?? 0"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/brouillon']" [class.active]="currentStatus === 'brouillon'" (click)="filterByStatus('brouillon')">
                    Brouillon <app-tab-count [count]="counts['Brouillon'] ?? 0"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/cree']" [class.active]="currentStatus === 'cree'" (click)="filterByStatus('cree')">
                    Crée <app-tab-count [count]="counts['Crée'] ?? 0"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/annule']" [class.active]="currentStatus === 'annule'" (click)="filterByStatus('annule')">
                    Annulé <app-tab-count [count]="counts['Annulé'] ?? 0"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/negociation']" [class.active]="currentStatus === 'negociation'" (click)="filterByStatus('negociation')">
                    Négociation <app-tab-count [count]="counts['Négociation'] ?? 0"></app-tab-count>
                </a>
            </li>
            <li class="nav-item">
                <a class="nav-link" [routerLink]="['/vente/devis/accepte']" [class.active]="currentStatus === 'accepte'" (click)="filterByStatus('accepte')">
                    Accepté <app-tab-count [count]="counts['Accepté'] ?? 0"></app-tab-count>
                </a>
            </li>
        </ul>
        <div class="container-fluid" style="padding: 0; width: 100%; max-width: 100%;">
            <router-outlet></router-outlet>
        </div>
    </div>
